export enum RECO_CORE_EVENT {
  REGISTER_CINEMA = "reco-core.cinema.register",
  REGISTERED_CINEMA = "reco-core.cinema.registered",
}
